import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PosStation, StationApp } from '../../_models/fundraising/PosStation';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';


@Injectable()
export class StationService {

  public apiUrl = getUrl();

  constructor(
    private http: HttpClient,
    private jwtTokenService: JWTTokenService) { }

    public getAll(): Observable<PosStation[]> {
        return this.http.get<PosStation[]>(getUrl('fundraising/pos/station'), this.requestOptionsAuthenticated('portal'));
    }

    public getById(id: number): Observable<PosStation> {
      return this.http.get<PosStation>(getUrl(`fundraising/pos/station/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public create(data: PosStation): Observable<PosStation[]> {
      return this.http.post<PosStation[]>(getUrl(`fundraising/pos/station/create`), data, this.requestOptionsAuthenticated('portal'));
    }

    public update(data: PosStation): Observable<PosStation[]> {
      return this.http.post<PosStation[]>(getUrl(`fundraising/pos/station/update`), data, this.requestOptionsAuthenticated('portal'));
    }

    public delete(id: number): Observable<any> {
      return this.http.get<any>(getUrl(`fundraising/pos/station/delete/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public stationOperatorLink(stationId: number, operatorId: number): Observable<any>  {
      const data = { stationId, operatorId }
      return this.http.post<any>(getUrl(`fundraising/pos/station/operator-link`), data, this.requestOptionsAuthenticated('portal'));
    }

    public createNewStationApp(data: StationApp): Observable<number> {
      return this.http.post<number>(getUrl(`fundraising/pos/station/app/create`), data, this.requestOptionsAuthenticated('portal'));
    }

    public getStationApps(): Observable<StationApp[]> {
      return this.http.get<StationApp[]>(getUrl('fundraising/pos/station/app'), this.requestOptionsAuthenticated('portal'));
    }

    public forceUpdate(id: number): Observable<void> {
      return this.http.get<void>(getUrl(`fundraising/pos/station/app/force/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public setCurrent(id: number): Observable<void> {
      return this.http.get<void>(getUrl(`fundraising/pos/station/app/current/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    private requestOptionsAuthenticated(tokenKey: string) {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken(tokenKey)),
        };
        return requestOptions;
    }

  }